export default "/fonts/vendor/katex/dist/KaTeX_SansSerif-Bold.woff?b9cd458ac6d5889ff9c388cf91b8ad51";